import type { Action } from 'svelte/action';
import { ObserverInstance, type ObserverCallback } from './ObserverInstance';

export const IsInView: Action<HTMLElement, ObserverCallback> = (node, callback) => {
	ObserverInstance.observe(node, callback);
	return {
		destroy() {
			ObserverInstance.unobserve(node);
		}
	};
};
